class HeroImageSwiper {
  constructor() {
    this.initHeroImageSwiper()
    this.hyphenateHeadings()
  }

  hyphenateHeadings = () => {
    let hyphenSelector = Array.from(document.querySelectorAll('.hyphenate'));

    hyphenSelector.forEach(element => {
      let str = element.innerHTML;
      element.innerHTML = str.replaceAll(/\|\|/ig , '<br>').replaceAll(/\|/ig , '&shy;').replaceAll(/_/ig , '&nbsp;');
    })
  }

  initHeroImageSwiper = () => {
    let content = document.querySelectorAll('.hero-image-slider .content-slide');
    content[0].classList.add('active');

    let heroImageSwiper = new Swiper(".hero-image-swiper", {
      slidesPerView: "auto",
      loop: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: true,
      },
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      }
    });

    heroImageSwiper.on('activeIndexChange', function () {
      let activeSlide = heroImageSwiper.slides[heroImageSwiper.activeIndex],
        id = activeSlide.getAttribute('data-slide'),
        activeContent = document.querySelector('.hero-image-slider .content-slide[data-slide="' + id + '"]')

        Array.from(content).forEach(item => {
          item.classList.remove('active');
        })

        activeContent.classList.add('active');
    });
  }
}

if (document.querySelector('.hero-image-slider')) {
  new HeroImageSwiper();
}
